export default {
  methods: {
    setLoadingState(state, id ='loading') {
      this[id] = state
    }
  },
}
